var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipmentActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#3AB44A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 29.8008C19.6 30.7949 18.7941 31.6008 17.8 31.6008C16.8059 31.6008 16 30.7949 16 29.8008C16 28.8067 16.8059 28.0008 17.8 28.0008C18.7941 28.0008 19.6 28.8067 19.6 29.8008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29.8008C28 30.7949 27.1941 31.6008 26.2 31.6008C25.2059 31.6008 24.4 30.7949 24.4 29.8008C24.4 28.8067 25.2059 28.0008 26.2 28.0008C27.1941 28.0008 28 28.8067 28 29.8008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 14.8008C12.9373 14.8008 12.4 15.338 12.4 16.0008V28.0008C12.4 28.6635 12.9373 29.2008 13.6 29.2008H14.86C15.138 27.8314 16.3486 26.8008 17.8 26.8008C19.2514 26.8008 20.4621 27.8314 20.74 29.2008H22C22.6628 29.2008 23.2 28.6635 23.2 28.0008V16.0008C23.2 15.338 22.6628 14.8008 22 14.8008H13.6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 18.4008C26.1373 18.4008 25.6 18.938 25.6 19.6008V26.8608C25.7939 26.8214 25.9945 26.8008 26.2 26.8008C27.6514 26.8008 28.8621 27.8314 29.14 29.2008H30.4C31.0628 29.2008 31.6 28.6635 31.6 28.0008V22.0008C31.6 21.6825 31.4736 21.3773 31.2486 21.1523L28.8486 18.7523C28.6235 18.5272 28.3183 18.4008 28 18.4008H26.8Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentActive);
export default __webpack_public_path__ + "static/media/shipment-active.48c618fb15d0af3497480370980c5354.svg";
export { ForwardRef as ReactComponent };